import { css } from "@emotion/css";

export const AccountStyle = css`
  width: 100%;
  max-width: 688px;
  margin: auto;
`;

export const FormRowStyle = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;
